/**
 * Holds the meta data of a light source.
 */
class LightSourceMetaComponent {
    constructor(lightSourceWidth, lightSourceType, lightAngle, lightIntensity) {
        this.typeId = LightSourceMetaComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = false;
        this.lightSourceWidth = lightSourceWidth;
        this.lightSourceType = lightSourceType;
        this.lightAngle = lightAngle;
        this.lightIntensity = lightIntensity;
    }
    eq(other) {
        return (this.lightSourceWidth === other.lightSourceWidth &&
            this.lightSourceType === other.lightSourceType &&
            this.lightAngle === other.lightAngle &&
            this.lightIntensity === other.lightIntensity);
    }
}
LightSourceMetaComponent.id = 2067;
export default LightSourceMetaComponent;
//# sourceMappingURL=LightSourceMetaComponent.js.map